export default "__VITE_ASSET__HCtgQsiV__"